var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "v-height-flag" },
      [
        _c(
          "el-card",
          { attrs: { "body-style": { padding: "20px" } } },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-page-header",
                      {
                        attrs: { content: "文章详情" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handleEmit($event)
                          },
                        },
                      },
                      [
                        _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                          _vm._v("返回"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("el-card", { staticClass: "mt14 employees-card" }, [
          _c(
            "div",
            { staticClass: "card-box", staticStyle: { "margin-top": "20px" } },
            [
              _c("div", [
                _c("div", { staticClass: "main" }, [
                  _c("div", { staticClass: "header" }, [
                    _c("div", { staticClass: "futitle" }, [
                      _vm._v(_vm._s(_vm.data.title)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "futitle-time" }, [
                      _c("i", { staticClass: "iconfont iconriqishijian" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.data.time) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "futitle-time" }, [
                      _c("i", { staticClass: "iconfont iconyiyuedu" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.data.visit) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.data.content) },
                    }),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }